export default {"src":"/_next/static/image/src/images/Homepage/box-feeding-guide.335af3f09be3226e86845826eb916f10.svg","height":71,"width":179};